import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { IncomeStatementInterface } from '@app/interface/income-statement';
import { IncomeStatementApiService } from '@app/services/income-statement-api.service';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Guide5DetailsDialogComponent } from '@app/guide-details-dialog/guide-details-dialog.component';

@Component({
  selector: 'izy-dichiarazione-redditi',
  imports: [
    BackHeaderComponent,
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDividerModule,
  ],
  templateUrl: './dichiarazione-redditi.component.html',
  styleUrl: './dichiarazione-redditi.component.scss',
})
export class DichiarazioneRedditiComponent {
  incomeStatements: IncomeStatementInterface[] = [];
  isLoading = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private incomeStatementService: IncomeStatementApiService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.loadIncomeStatements();
    this.cdr.detectChanges();
  }

  loadIncomeStatements(): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.cdr.detectChanges();

    this.incomeStatementService.getAllStatements(organization_id).subscribe({
      next: (response) => {
        this.incomeStatements = response.results || [];
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error loading income statements:', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  openAttachment(attachmentUrl: string): void {
    if (attachmentUrl) {
      // Open the attachment in a new tab
      window.open(attachmentUrl, '_blank');

      // Alternative: download the file
      // const link = document.createElement('a');
      // link.href = attachmentUrl;
      // link.download = attachmentUrl.split('/').pop() || 'document';
      // link.target = '_blank';
      // link.click();
    }
  }

  navigateToTutorials() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    // console.log(org_id);
    this.router.navigate([`/${org_id}/guides`]);
  }

  openGuide5Dialog() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(Guide5DetailsDialogComponent, {
      width: '90vw',
      maxWidth: '1000px', // Slightly wider to accommodate the link
      maxHeight: '700px',
      data: {
        organizationId: organization_id,
        organization: [],
      },
    });
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }
}
